import {createFsCockpitAuthedAxiosInstance} from "./axiosFsCockpitAuthAdapter";
import {AxiosResponse} from "axios";

const PDF_GENERATOR_BASE_URL = process.env.REACT_APP_PDF_GENERATOR_BASE_URL;
const pdfGeneratorAxiosInstance = createFsCockpitAuthedAxiosInstance({baseURL: PDF_GENERATOR_BASE_URL});

export type WineMenuFormat = 'a4' | 'a4-half' | 'a5';
export type LeafletFormat = 'a6';
export type LabelFormat = 'custom';
export type MenuFormat = WineMenuFormat | LeafletFormat | LabelFormat;
export type PrintMode = "brochure" | "singlepages";

export interface GeneratePdfRequest {
    format: MenuFormat
    printMode: PrintMode
    template: string
    data: any
}

export interface GeneratedPdfResponse {
    url: string
}

export function generatePdf(request: GeneratePdfRequest): Promise<AxiosResponse<GeneratedPdfResponse>> {
    return pdfGeneratorAxiosInstance.request({
        method: 'POST',
        url: '/pdf',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        responseType: 'json',
        data: {
            format: request.format,
            printMode: request.printMode,
            template: request.template,
            data: request.data
        }
    });
}